import pattern from '../../pattern.svg';
import { useTranslation } from 'react-i18next';
import { useGlobal } from '../../Core/GlobalState/Store';
import { useStep } from '../Base/StepContext.jsx';
import LoadingSpinner from '../ReusableComponents/LoadingSpinner';
export default function FormLayout({
  children,
  title,
  description,
  loadingText,
  loading = false,
}) {
  const { t } = useTranslation();
  const { totalSteps, activeStep } = useStep();
  const { pluginUrl } = useGlobal();
  return (
    <div
      className="w-full flex flex-col !border-solid !border-l !border-r border-gray-300 border-1"
      style={{
        backgroundImage: `linear-gradient(135deg, #fff 0%, rgba(255,255,255,0) 33.9%, #fff 100%), url(${pluginUrl + pattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
      }}
    >
      <div className="mb-2 h-[220px] md:h-[250px] text-center flex flex-col justify-center items-center max-w-[640px] mx-auto">
        <div
          className="text-uppercase font-medium text-sm"
          style={{ color: '#BF4B30' }}
        >
          {t('header_current_step', {
            currentStep: activeStep + 1,
            totalSteps: totalSteps,
          })}
        </div>
        <h1 className="text-2xl md:text-5xl font-bold"> {t(title)}</h1>
        <div>
          {description && <div className="!mt-4">{t(description)}</div>}
        </div>
      </div>

      <div>
        {loading && (
          <div className="fixed inset-0 bg-gray-500/75 transition-opacity w-full h-full flex items-center justify-center z-[10000]">
            <div className="bg-white w-[95%] h-auto md:w-1/2 md:h-1/4 rounded-lg text-black text-center flex flex-col items-center justify-center p-2 md:p-6">
              <LoadingSpinner />
              <p className="mt-4">
                {t(loadingText || 'loading_text_verification')}
              </p>
            </div>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
